import { render, staticRenderFns } from "./block_video.vue?vue&type=template&id=017a7ace"
import script from "./block_video.vue?vue&type=script&lang=js"
export * from "./block_video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports